// extracted by mini-css-extract-plugin
module.exports = {"userPanel":"UserPanel_userPanel__3IFmh","deleteButton":"UserPanel_deleteButton__3Obdq"};